import { Input } from '@mantine/core';
import React, { useState } from 'react';
import { Json } from '../../types';
import { Button } from '../Button/Button';
import PromptSuggestions from '../PromptSuggestions/PromptSuggestions';
import classes from './Prompt.module.css';
import { Wrapper } from './Prompt.style';

export type PromptProps = {
  onPrompt: (prompt: string) => void;
  suggestions: Json[];
  placeholder: string;
  ctaText: string;
  ctaColor: string;
  isLoading?: boolean;
  children?: React.ReactNode;
};

export function Prompt(props: PromptProps) {
  const { placeholder, suggestions = [], ctaText, ctaColor, isLoading } = props;
  const [prompt, setPrompt] = useState<string>('');
  const [isFocused, setIsFocused] = useState(false);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setPrompt(event.target.value);
  }

  function onPick(value: string) {
    setPrompt(value);
  }

  function onFocus() {
    setIsFocused(true);
  }

  function onBlur() {
    setTimeout(() => {
      setIsFocused(false);
    }, 500);
  }

  function onPrompt() {
    props.onPrompt(prompt);
    setPrompt('');
  }

  function onKeyDown(ev: React.KeyboardEvent<HTMLInputElement>) {
    if (ev.code !== 'Enter' || !prompt) {
      return;
    }

    setTimeout(() => {
      onPrompt();
    }, 50);
  }

  return (
    <Wrapper className='Prompt-wrapper' data-testid='Prompt-wrapper'>
      <Input
        className={classes.input}
        placeholder={placeholder}
        value={prompt}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      {!isLoading && (
        <PromptSuggestions
          items={suggestions}
          isFocused={isFocused}
          prompt={prompt}
          onPick={onPick}
        />
      )}
      {props.children}
      <Button analytics loading={isLoading} onClick={onPrompt} color={ctaColor} data-track>
        <span style={{ fontSize: '20px', marginLeft: '-2px' }}>✨</span>&nbsp;
        {ctaText}
        &nbsp;
        <span>⏎</span>
      </Button>
    </Wrapper>
  );
}

export default Prompt;
